import React from 'react'
import './NotFound.css'

export default function NotFound() {
  return (
    <>
    <div className='main-error'> 
    <div class="error-container">
        <div class="error-title second-color">404</div>
        <div class="error-message second-color">Oops! The page you're looking for doesn't exist.</div>
        <a href="/" class="btn btn-danger btn-lg">Go Back to Home</a>
    </div>
    </div>

    </>
  )
}
